import { useEffect } from "react";

export const useAutoScrollOnChange = ({ elementId, changeValue }) => {
  useEffect(() => {
    const element = document.getElementById(elementId);
    const width = element.scrollWidth;
    element.scrollLeft = width;
  }, [elementId, changeValue]);
};
